import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { NavigationView } from 'app/shared/model/navigation-view';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class NavigationStore {
    constructor(router) {
        this.router = router;
        this.currentView$ = new BehaviorSubject(NavigationView.DASHBOARD);
        this.path$ = new BehaviorSubject([]);
    }
    setCurrentView(view) {
        this.currentView$.next(view);
    }
    getCurrentView() {
        return this.currentView$.asObservable();
    }
    getCurrentViewSnapshot() {
        return this.currentView$.getValue();
    }
    initNavigationPath() {
        this.path$.next([]);
    }
    setPathFromTree(tree, id) {
        const path = [];
        this.extractPathFromTree(tree, id, path);
        this.path$.next(path.reverse());
    }
    getPath() {
        return this.path$.asObservable();
    }
    extractPathFromTree(root, id, path) {
        if (!root) {
            return false;
        }
        // Cas d'un ouvrage (onglet document)
        if (root.typeElement === 'OUVRAGE') {
            path.push({ active: root.canAccess, name: root.nom, element: root });
            return true;
        }
        // On cherche un noeud avec l'id passé en paramètre (noeud courant, ou sous-noeuds récursivement)
        if (root.id === id || (root.children && root.children.some(child => this.extractPathFromTree(child, id, path)))) {
            path.push({ active: root.canAccess, name: root.nom, element: root });
            return true;
        }
        return false;
    }
}
NavigationStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NavigationStore_Factory() { return new NavigationStore(i0.ɵɵinject(i1.Router)); }, token: NavigationStore, providedIn: "root" });
